import React from 'react';
import Routes from './routes';

function App() {
    return (
        <div className="app">
            <Routes />
        </div>
    );
}

export default App;
